import { render, staticRenderFns } from "./CabecalhoEmailCartao.vue?vue&type=template&id=ff309846&scoped=true"
import script from "./CabecalhoEmailCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./CabecalhoEmailCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CabecalhoEmailCartao.vue?vue&type=style&index=0&id=ff309846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff309846",
  null
  
)

export default component.exports